
import { defineComponent, PropType, SetupContext, ref } from "vue";
import {
  FRIDGE_ROOM_ID_TYPE,
  PantryFridgeRoomData,
  PantryCameraDateData,
  FridgeCameraRoomInfo
} from "@/types/pantry";
import NativeClient from "@/client/native-client";
import PantryImageRoomView from "./PantryImageRoomView.vue";
import PantryImageRoomHorizontalView from "./PantryImageRoomHorizontalView.vue";
import PantryImageRoomFreezerView from "./PantryImageRoomFreezerView.vue";
import CommonUtil from "@/utils/common-utils";
export default defineComponent({
  name: "PantryImageView",
  components: {
    PantryImageRoomView,
    PantryImageRoomHorizontalView,
    PantryImageRoomFreezerView
  },
  props: {
    rooms: {
      type: Array as PropType<PantryFridgeRoomData[]>,
      default: null
    },
    imageUpdate: {
      type: Number,
      default: 0,
      required: true
    },
    selectRoomId: {
      type: Number,
      required: true
    },
    cameraRoomInfo: {
      type: FridgeCameraRoomInfo,
      default: null,
      required: true
    },
    applianceId: {
      type: String,
      default: null,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const getImages = (roomId: number) => {
      if (props.rooms == null || props.rooms.length == 0) {
        NativeClient.sendDebugLog(
          "PantryImageView getImages roomId=" +
            roomId +
            " null"
        );
        return null;
      }
      let roomData = null;
      for (const room of props.rooms) {
        if (room.roomId == roomId) {
          roomData = room;
        }
      }
      NativeClient.sendDebugLog(
        "PantryImageView getImages roomId=" +
          roomId +
          " result=" +
          CommonUtil.jsonStringify(roomData)
      );
      return roomData;
    };
    const onSelectRoom = (id: number) => {
      context.emit("select-room", id);
    };
    const onSelectImage = (roomId: number, areaId: number, fileName: string) => {
      NativeClient.sendDebugLog("PantryImageView onSelectImage");
      context.emit("select-image", roomId, areaId, fileName);
    };
    const onShowDate = (roomId: number, areaId: number, selectId: number, list: Array<PantryCameraDateData>) => {
      NativeClient.sendDebugLog("PantryImageView onShowDate roomId=" + roomId + " areaId=" + areaId + " selectId=" + selectId + " dateList=" + JSON.stringify(list));
      context.emit("show-date", roomId, areaId, selectId, list);
    };

    return {
      getImages,
      FRIDGE_ROOM_ID_TYPE,
      onSelectRoom,
      onSelectImage,
      onShowDate
    };
  }
});
